export interface ValidationResult {
  result: boolean,
  message: string
}

export function validationNumber(value: any, min?: number, max?: number): ValidationResult {
	const validationResult = {
		result: false,
		message: ''
	}

	const parsedValue = Number(value);
	if (!parsedValue || !Number.isFinite(parsedValue)){
		validationResult.message = "Valore non valido";
		return validationResult;
	}
	if (min && parsedValue < min){
		validationResult.message = `Valore minimo: ${min}`;
		return validationResult;
	}
	if (max && parsedValue > max){
		validationResult.message = `Valore massimo: ${max}`;
		return validationResult;
	}

	validationResult.result = true;
	return validationResult;
}